import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import SaleSharedFile from 'components/Tvendo/Sale/Operations/SaleOrder/SaleSharedFile';

export default function RuleApprovedOrder() {
  return (
    <SaleSharedFile
      title="Pedidos aprobados por regla"
      excelName="Pedidos_aprobados_por_regla"
      endpoint="sale/order/approved-by-rule"
      permission={{
        show: ConstantPermissions.LOGI_RULE_DISCOUNTS_SHOW,
        store: -1,
      }}
    />
  );
}
